import { useCallback } from 'react';

import { useCurrentUser } from './useCurrentUser';

export const useReliableUserRefresh = () => {
  const { refetch } = useCurrentUser();

  const reliableRefresh = useCallback(async () => {
    // First delay: 5 seconds
    await new Promise((resolve) => setTimeout(resolve, 5000));

    // First refresh (awaited)
    const result = await refetch();

    // Second refresh: 10 seconds later (fire and forget)
    setTimeout(() => {
      void refetch();
    }, 10_000);

    return result;
  }, [refetch]);

  return { reliableRefresh };
};
